var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { $settings } from 'ziphy-web-shared/basic/entities/settings';
import { Button } from 'ziphy-web-shared/basic/lib/buttons';
import { useMobxForm } from 'ziphy-web-shared/basic/lib/forms';
import { Select } from 'ziphy-web-shared/basic/lib/forms/fields';
import { Modal, ModalToolbarBtn } from 'ziphy-web-shared/basic/lib/utilities/modals';
import { $loader } from 'ziphy-web-shared/basic/utils';
import { $notes } from '../../Notes.store';
import styles from './Unlock.module.scss';
const UnlockModal = ({ _core }) => {
    var _a;
    const { t } = useTranslation();
    const form = useMobxForm(useMemo(() => ({
        initialValues: {
            reasonId: null,
        },
        fieldsConfig: {
            reasonId: { validate: ['required'] },
        },
    }), []));
    const reasonId = form.field('reasonId', null);
    const reasonItems = ((_a = $settings.optionsByScope['reason_for_editing_notes']) === null || _a === void 0 ? void 0 : _a.map((x) => ({
        id: x.id,
        text: x.value,
    }))) || [];
    const handleSubmit = form.submit((data) => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield $notes.unlock(data.reasonId);
        if (!response.error) {
            _core.onHide();
        }
    }));
    return (_jsxs(Modal, Object.assign({ size: 'lg', centered: true, scrollable: true }, { children: [_jsx("div", Object.assign({ className: "modal-toolbar" }, { children: _jsx(ModalToolbarBtn, { type: "close", action: () => _core.onHide(false) }) })), _jsx(Modal.Header, Object.assign({ className: 'pb-0' }, { children: t('label.unlock_notes') })), _jsxs(Modal.Body, { children: [_jsx("div", Object.assign({ className: styles.description }, { children: t('text.unlock_notes_reason') })), _jsx("form", Object.assign({ id: form.id, onSubmit: $loader.registerHandler(form.id, handleSubmit), className: 'mt-20' }, { children: _jsx(Select, { field: reasonId, mode: ['sm'], items: reasonItems, placeholder: t('label.select_unlock_reason'), search: true }) }))] }), _jsx(Modal.Footer, { children: _jsxs("div", Object.assign({ className: styles.buttons }, { children: [_jsx(Button, Object.assign({ mode: ['primary', 'sm'], form: form.id, isLoading: $loader.isRunHandler(form.id) }, { children: t('btn.unlock_notes') })), _jsx(Button, Object.assign({ mode: ['secondary', 'sm', 'min110'], onClick: _core.onHide }, { children: t('btn.cancel') }))] })) })] })));
};
UnlockModal.displayName = 'UnlockModal';
export default observer(UnlockModal);
